var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('head-dept-rating-directions-index')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }